import { SERVICE_ENV } from '../constant';

export const onlyEmailValidCharacterPattern = RegExp(`^[\\w\\-@.${SERVICE_ENV !== 'production' ? '+' : ''}]+$`);
export const isValidEmail = (email: string) => {
  return onlyEmailValidCharacterPattern.test(email);
};
